import {CodeCheck} from './CodeCheck';

export default CodeCheck;
